import { GetResolvedDatesRequest, ResolvedDate, Result } from "@models";
import requests from "./agent";

export const availabilityService = {
  getResolvedDates: async (request: GetResolvedDatesRequest) => {
    const response = await requests.post<Result<ResolvedDate[]>>(
      "/api/Availability/GetResolvedDates",
      request
    );
    return response.result;
  },
};
